import React, { Component } from "react";
export default class LanguageSpellingSection extends Component {
  render() {
    var {
      spelling_envelop_text_status,
      spelling_envelop_text,
      spelling_skate_board_text_status,
      spelling_skate_board_text,
      spelling_constructing_text_status,
      spelling_constructing_text,
      spelling_partner_text_status,
      spelling_partner_text,
      spelling_biscuit_text_status,
      spelling_biscuit_text,
      spelling_lawnmower_text_status,
      spelling_lawnmower_text,
      spelling_deliver_text_status,
      spelling_deliver_text,
      spelling_recorded_text_status,
      spelling_recorded_text,
      spelling_coarhanger_text_status,
      spelling_coarhanger_text,
      spelling_orchestra_text_status,
      spelling_orchestra_text,
      spelling_screwdriver_text_status,
      spelling_screwdriver_text,
      spelling_score,
      spelling_brought_text_status,
      spelling_brought_text,
    } = this.props.data;
    return (
      <div className="row border border-dark language_spelling_section">
        <div className="col-lg-12">
          <table className="w-100 fs-18">
            <tbody>
              <tr>
                <td>
                  <br />
                  <div className="row p-3">
                    <div className="col-lg-6">
                      <span className="fs-18 mb-4">1. Envelope </span>{" "}
                      <input
                        value={spelling_envelop_text}
                        name="spelling_envelop_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-18 mb-4">2. Skateboard </span>{" "}
                      <input
                        value={spelling_skate_board_text}
                        name="spelling_skate_board_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-18 mb-4">3. Constructing </span>
                      <input
                        value={spelling_constructing_text}
                        name="spelling_constructing_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-18 mb-4">4. Partner </span>{" "}
                      <input
                        value={spelling_partner_text}
                        name="spelling_partner_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-18 mb-4">5. Biscuit </span>
                      <input
                        value={spelling_biscuit_text}
                        name="spelling_biscuit_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-18 mb-4">6. Lawnmower </span>{" "}
                      <input
                        value={spelling_lawnmower_text}
                        name="spelling_lawnmower_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-18 mb-4">7. Deliver </span>{" "}
                      <input
                        value={spelling_deliver_text}
                        name="spelling_deliver_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-18">8. Recorded </span>{" "}
                      <input
                        value={spelling_recorded_text}
                        name="spelling_recorded_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-18 mb-4">9. Coathanger </span>{" "}
                      <input
                        value={spelling_coarhanger_text}
                        name="spelling_coarhanger_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-18 mb-4">10. Orchestra </span>{" "}
                      <input
                        value={spelling_orchestra_text}
                        name="spelling_orchestra_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-18 mb-4">11. Screwdriver </span>{" "}
                      <input
                        value={spelling_screwdriver_text}
                        name="spelling_screwdriver_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <span className="fs-18">12. Brought </span>
                      <input
                        value={spelling_brought_text}
                        name="spelling_brought_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                  </div>
                  <hr />
                  <div className="col-lg-6">
                    <span className="fs-18">Score (0-12) </span>
                    <input
                      type="number"
                      disabled
                      name="spelling_score"
                      value={spelling_score}
                      className="ecas-input-field"
                      placeholder="Score"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
